<template>
  <div class="user-block">
    <img class="agent-photo" :src="agent.photo" v-if="agent.photo !== null">
    <span class="agent-name">{{agent.name}}</span>
    <span class="agent-phone">{{agent.phone}}</span>
<!--    <a :href="`https://api.whatsapp.com/send?phone=79059246565`">-->
    <a :href="`https://api.whatsapp.com/send?phone=7${agent.clean_phone}`" class="agent-btn whatsapp-btn">
      Написать в whatsapp
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M16.2881 32C25.1246 32 32.2881 24.8366 32.2881 16C32.2881 7.16344 25.1246 0 16.2881 0C7.45153 0 0.288086 7.16344 0.288086 16C0.288086 24.8366 7.45153 32 16.2881 32Z" fill="#27AE60"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8155 24.9017H16.8115C15.2192 24.9012 13.6546 24.5016 12.265 23.7437L7.22144 25.0667L8.57118 20.1366C7.73859 18.6937 7.30049 17.057 7.3012 15.3802C7.30329 10.1345 11.5713 5.8667 16.8154 5.8667C19.3605 5.8678 21.7493 6.85861 23.5456 8.65697C25.3418 10.4552 26.3305 12.8456 26.3295 15.3877C26.3274 20.6322 22.0611 24.8996 16.8155 24.9017ZM12.4987 22.0213L12.7874 22.1927C14.0016 22.9131 15.3933 23.2944 16.8123 23.2949H16.8155C21.174 23.2949 24.7214 19.7475 24.7231 15.3872C24.7239 13.2742 23.9022 11.2874 22.4092 9.79269C20.9162 8.29796 18.9308 7.47439 16.8186 7.47366C12.4567 7.47366 8.90929 11.0208 8.90756 15.3807C8.90694 16.8749 9.32502 18.3301 10.1166 19.5891L10.3046 19.8883L9.50576 22.8064L12.4987 22.0213ZM21.283 17.4361C21.4488 17.5162 21.5608 17.5703 21.6086 17.6501C21.668 17.7492 21.668 18.2252 21.47 18.7806C21.2718 19.3359 20.3221 19.8427 19.8654 19.9109C19.4558 19.9722 18.9375 19.9977 18.3681 19.8167C18.0228 19.7072 17.58 19.5609 17.0128 19.316C14.7842 18.3536 13.2781 16.1936 12.9935 15.7854C12.9735 15.7568 12.9596 15.7368 12.9518 15.7264L12.9499 15.7238C12.8241 15.556 11.9811 14.4313 11.9811 13.2672C11.9811 12.1722 12.519 11.5982 12.7666 11.334C12.7836 11.3159 12.7992 11.2993 12.8131 11.284C13.031 11.046 13.2886 10.9865 13.4471 10.9865C13.6055 10.9865 13.7642 10.988 13.9027 10.995C13.9198 10.9958 13.9376 10.9957 13.9559 10.9956C14.0945 10.9948 14.2672 10.9938 14.4376 11.403C14.5031 11.5605 14.599 11.794 14.7002 12.0403C14.9047 12.5383 15.1307 13.0885 15.1705 13.1682C15.2299 13.2872 15.2696 13.4259 15.1903 13.5847C15.1784 13.6085 15.1674 13.6309 15.1569 13.6524C15.0974 13.7739 15.0536 13.8633 14.9526 13.9812C14.9129 14.0276 14.8718 14.0776 14.8308 14.1276C14.749 14.2272 14.6672 14.3268 14.596 14.3977C14.477 14.5163 14.3531 14.6449 14.4918 14.8829C14.6305 15.1209 15.1076 15.8993 15.8143 16.5297C16.5739 17.2073 17.2342 17.4937 17.5689 17.6389C17.6342 17.6672 17.6872 17.6902 17.726 17.7096C17.9637 17.8286 18.1023 17.8087 18.241 17.6501C18.3797 17.4915 18.8353 16.9559 18.9937 16.718C19.1522 16.4801 19.3107 16.5197 19.5286 16.599C19.7465 16.6784 20.9153 17.2534 21.153 17.3724C21.1994 17.3957 21.2428 17.4166 21.283 17.4361Z" fill="#FDFDFD"/>
      </svg>
    </a>


    <div class="text-center" v-if="complete">
      Заявка отправлена, мы с вами свяжемся в ближайшее время
    </div>
    <div v-else class="w-100">
      <div class="call-me-frm" v-if="call_me">
        <input type="text" placeholder="Ваше имя" v-model="call_me_name">
        <input type="text" placeholder="Ваш телефон" v-model="call_me_phone">
        <div class="c-red text-center m-b-10" v-if="error">Заполните форму</div>
        <div class="text-center" v-if="sending">отправка ...</div>
        <button class="btn btn-primary" v-else @click="sendMessage">Заказать звонок</button>
      </div>
      <span class="agent-btn callme-btn" v-else @click="toggleCallMe">
      Перезвоните мне
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M16.2239 28C16.0089 28 15.8291 27.9271 15.6845 27.7814C15.5398 27.6356 15.4675 27.4544 15.4675 27.2378C15.4675 27.0212 15.5398 26.8419 15.6845 26.7001C15.8291 26.5582 16.0089 26.4872 16.2239 26.4872H25.6982C25.8178 26.4872 25.9161 26.4488 25.9931 26.3718C26.07 26.2949 26.1085 26.1966 26.1085 26.077V15.9693C26.1085 14.6804 25.8392 13.45 25.3008 12.2782C24.7623 11.1064 24.0393 10.0735 23.1315 9.17952C22.2239 8.2855 21.1786 7.57267 19.9957 7.04105C18.8128 6.50943 17.5769 6.24362 16.288 6.24362C14.9991 6.24362 13.7632 6.50943 12.5803 7.04105C11.3974 7.57267 10.3521 8.2855 9.4444 9.17952C8.53669 10.0735 7.81362 11.1064 7.27517 12.2782C6.7367 13.45 6.46747 14.6804 6.46747 15.9693V23.5385C6.46747 23.6932 6.42068 23.8173 6.3271 23.9109C6.2335 24.0045 6.10936 24.0513 5.95467 24.0513C5.3068 24.0513 4.75595 23.8244 4.3021 23.3706C3.84826 22.9167 3.62134 22.3659 3.62134 21.718V19.0513C3.62134 18.6086 3.74356 18.2077 3.988 17.8488C4.23245 17.4898 4.55467 17.1881 4.95467 16.9437L5.01624 15.1898C5.1393 13.6531 5.52562 12.242 6.17517 10.9565C6.82475 9.67102 7.66065 8.56845 8.68287 7.64879C9.70507 6.72914 10.8692 6.01076 12.1752 5.49365C13.4811 4.97656 14.8521 4.71802 16.288 4.71802C17.7375 4.71802 19.1153 4.97443 20.4213 5.48725C21.7273 6.00007 22.888 6.71973 23.9033 7.64622C24.9187 8.57273 25.7512 9.6753 26.4008 10.9539C27.0503 12.2325 27.4366 13.6377 27.5597 15.1693L27.6213 16.8898C28.0213 17.0898 28.3435 17.365 28.5879 17.7155C28.8324 18.0659 28.9546 18.4445 28.9546 18.8513V21.918C28.9546 22.3385 28.8324 22.7206 28.5879 23.0642C28.3435 23.4077 28.0213 23.6795 27.6213 23.8795V26.077C27.6213 26.6013 27.4319 27.0529 27.053 27.4317C26.6741 27.8106 26.2225 28 25.6982 28H16.2239ZM12.5444 18.5257C12.2948 18.5257 12.0764 18.4321 11.8893 18.2449C11.7021 18.0577 11.6085 17.8338 11.6085 17.5731C11.6085 17.321 11.7021 17.1047 11.8893 16.9244C12.0764 16.7441 12.3004 16.6539 12.5611 16.6539C12.8132 16.6539 13.0294 16.7454 13.2098 16.9286C13.3901 17.1117 13.4803 17.3321 13.4803 17.5898C13.4803 17.8394 13.3887 18.0577 13.2056 18.2449C13.0225 18.4321 12.8021 18.5257 12.5444 18.5257ZM20.0315 18.5257C19.782 18.5257 19.5636 18.4321 19.3764 18.2449C19.1892 18.0577 19.0956 17.8338 19.0956 17.5731C19.0956 17.321 19.1892 17.1047 19.3764 16.9244C19.5636 16.7441 19.7875 16.6539 20.0482 16.6539C20.3003 16.6539 20.5166 16.7454 20.6969 16.9286C20.8773 17.1117 20.9674 17.3321 20.9674 17.5898C20.9674 17.8394 20.8759 18.0577 20.6928 18.2449C20.5096 18.4321 20.2892 18.5257 20.0315 18.5257ZM8.78287 16.6129C8.70254 15.3787 8.87519 14.2581 9.30084 13.2513C9.72646 12.2445 10.3012 11.3902 11.0252 10.6885C11.7491 9.98681 12.5811 9.44663 13.5213 9.06798C14.4615 8.68936 15.4059 8.50005 16.3546 8.50005C18.2572 8.50005 19.8674 9.10262 21.1854 10.3078C22.5033 11.5129 23.3093 13.0154 23.6033 14.8154C21.6341 14.7932 19.8914 14.2641 18.3751 13.2283C16.8589 12.1923 15.6931 10.8479 14.8777 9.19492C14.5393 10.8923 13.8299 12.3949 12.7495 13.7026C11.6692 15.0103 10.347 15.9804 8.78287 16.6129Z" fill="white"/>
      </svg>
    </span>
    </div>
    <div class="m-t-20 text-right">
      <a :href="`/realtor/${agent.id}`" class="agent-offers-link">Посмотреть все объекты</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['agent'],
    data: function() {
      return {
        error: false,
        phone: '',
        sending: false,
        complete: false,
        call_me: false,
        call_me_name: '',
        call_me_phone: ''
      }
    },
    mounted() {
    },
    methods: {
      toggleCallMe() {
        this.call_me = !this.call_me
      },
      sendMessage() {
        if (this.call_me_phone.length === 0) {
          this.error = true
        } else {
          if (!this.sending) {
            this.error = false
            let _this = this;
            const headers = {'X-CSRF-Token': this.csrfToken,'X-Requested-With' : 'XMLHttpRequest','Content-Type': 'application/json'};
            this.sending = true;
            fetch('/consultation', {
              method: 'POST',
              headers:headers,
              body: JSON.stringify({
                source: 'agent',
                name:this.call_me_name,
                phone:this.call_me_phone,
                offer_id: document.querySelector('h1')?.dataset.id
              })
            })
                .then(response => response.json())
                .then(function(data) {
                  _this.sending = false;
                  _this.complete = true;
                })
                .catch((error) => {
                  // _this.error = error;
                  _this.saving = false;
                });
          }
        }
      }
    },
    computed: {
      csrfToken() {
        return window.document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    }
  }
</script>

<style lang="scss">
  .c-red {
    color: red;
  }
  .user-block {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .agent-photo {
    height: 100px;
    width: 100px;
    border-radius: 50%;
    margin-bottom: 10px;
    display: block;
  }

  .agent-name {
    color: #000;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 10px;
  }

  .agent-phone {
    color: #0B56A6;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    margin-bottom: 25px;
  }

  .agent-btn {
    width: 100%;
    border-radius: 5px;
    display: flex;
    padding: 8px 24px;
    justify-content: space-between;
    align-items: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    text-decoration: none;
    cursor: pointer;
  }

  .whatsapp-btn {
    background: #27AE60;
    margin-bottom: 10px;
  }

  .callme-btn {
    background: #0B56A6;
  }

  .agent-offers-link {
    color: #0B56A6;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    text-decoration: none;
  }

  .call-me-frm {
    width: 100%;
    display: flex;
    flex-direction: column;
    input[type=text] {
      width: 100%;
      height: 48px;
      outline: none;
      margin-bottom: 10px;
      padding: 0 10px;
    }

  }

  @media (max-width: 1400px) {
    .agent-btn {
      font-size: 14px;
      padding: 8px 12px;
    }
  }
</style>